import { useEffect, useState } from 'react';

interface DeferredMountProps {
  children: React.ReactNode;
}

/** Runs children after the browser is idle to avoid competing with above-the-fold metrics. */
export function DeferredMount({ children }: DeferredMountProps) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof window.requestIdleCallback === 'function') {
      const id = window.requestIdleCallback(() => {
        setReady(true);
      });
      return () => {
        window.cancelIdleCallback(id);
      };
    }

    const timeoutId = window.setTimeout(() => {
      setReady(true);
    }, 150);
    return () => {
      window.clearTimeout(timeoutId);
    };
  }, []);

  if (!ready) {
    return null;
  }

  return children;
}
